import { Deserializable } from '../deserializable';

import {LogAction} from '../log/logaction';
import {CalendarDepart} from './calendardepart';



export  class CalendarDepartLog implements Deserializable
{
  public calendarDepart: CalendarDepart;
  public logAction: LogAction;
  deserialize(input: any): this {
    Object.assign(this, input);
    this.calendarDepart = input.entity != null ?  new CalendarDepart().deserialize(input.entity) : null;
    this.logAction = input.logAction != null ?  new LogAction().deserialize(input.logAction) : null;
    return this;
  }
}
